import { TTnaTemplatesActions } from './tna-templates.actions';
import { TNA_TEMPLATE_LISTING_ITEMS_PER_PAGE_LIST } from './tna-templates.facade';
import { TTnaTemplatesActionType, TTnaTemplateState } from './tna-templates.models';

export const initialState: TTnaTemplateState = {
  templateListingInfo: null,
  userPaginationOption: {
    pageNo: 1,
    pageSize: TNA_TEMPLATE_LISTING_ITEMS_PER_PAGE_LIST[0],
  },
  tnaDefaultSteps: null,
  tnaDefaultStepsLoader: false,
  tnaTemplateDetails: null,
};

export function tnaTemplatesReducer(state = initialState, action: TTnaTemplatesActions): TTnaTemplateState {
  switch (action.type) {
    case TTnaTemplatesActionType.GetTnaTemplateList:
      return {
        ...state,
        templateListingInfo: null,
      };
    case TTnaTemplatesActionType.GetTnaTemplateListSuccess:
      return {
        ...state,
        templateListingInfo: action.tnaTemplateListRes,
      };
    case TTnaTemplatesActionType.SetUserPaginationOption:
      return {
        ...state,
        userPaginationOption: action.userPaginationOption,
      };
    case TTnaTemplatesActionType.SetTnaDefaultStepsLoader:
      return {
        ...state,
        tnaDefaultStepsLoader: action.showLoader,
      };
    case TTnaTemplatesActionType.GetTnaDefaultStepsSuccess:
      return {
        ...state,
        tnaDefaultSteps: action.defaultTnASteps,
      };
    case TTnaTemplatesActionType.GetTnaTemplateDetails:
      return {
        ...state,
        tnaTemplateDetails: null,
      };
    case TTnaTemplatesActionType.GetTnaTemplateDetailsSuccess:
      return {
        ...state,
        tnaTemplateDetails: action.tnATemplateDetails,
      };
    case TTnaTemplatesActionType.ClearTnaTemplateDetails:
      return {
        ...state,
        tnaTemplateDetails: null,
      };
    default:
      return state;
  }
}
